import comp from "./SubmissionViewer";
export default comp;
